module.exports = __webpack_public_path__ + "static/media/logo.73e2c36e.svg";